<script setup lang="ts">

import { onMounted, ref, getCurrentInstance } from "vue";
import { type IBasicMap, useGoogle } from "..";

const model = defineModel<IBasicMap>( { required: true } );
const mapId = ref( '' );
const map = ref<any>( null );

onMounted( async () =>
{
    mapId.value = String( getCurrentInstance()!.uid );
    const google = useGoogle();
    map.value = await google.createMap( mapId.value, model.value );
} );

</script>

<template>

    <div :style="{ width: model.size.width, height: model.size.height }">
        <div v-show="map != null"
             :id="mapId" 
             :style="{ width: model.size.width, height: model.size.height }">
        </div>    
        <img v-if="map == null"
             src="@/assets/images/marketplace/map-thumb.png"/>
    </div>

</template>